<rotec-pages-v2>
  <a [routerLink]="overviewLink" routerLinkActive="pages-active-link">
    <h3 translate>Overview</h3>
  </a>
  <a [routerLink]="machineTasksLink" routerLinkActive="pages-active-link">
    <h3 translate>Machine Tasks</h3>
  </a>
  <a [routerLink]="machineHistoryLink" routerLinkActive="pages-active-link">
    <h3 translate>Machine History</h3>
  </a>
  <a [routerLink]="toolingTasksLink" routerLinkActive="pages-active-link">
    <h3 translate>Tooling Tasks</h3>
  </a>
  <a [routerLink]="toolingHistoryLink" routerLinkActive="pages-active-link">
    <h3 translate>Tooling History</h3>
  </a>
</rotec-pages-v2>
